import axios from "axios";

export let headers = {
	"Tenant-Access-Token": "ZjJhYjE2YjI0NzJlMDg0YjQ0ZWRlMzViOGZlYWUwZjU=",
	"Tenant-Access-Key": "FUYVrk_ej48ypg",
};

export const api = axios.create({
	baseURL: "https://immersive-game-india.confirmu.com",
	headers,
});

export const BASE_URL = "https://immersive-game-india.confirmu.com";
